import React from 'react';
import * as PropTypes from 'prop-types';
import { getXPathForElement } from 'utils';

export class DropZone extends React.Component {
  state = {
    selectorId: 'dragbox',
    dropZoneActive: null,
  };

  componentDidMount() {
    document.addEventListener('dragover', this._onDragOver, false);
    document.addEventListener('dragleave', this._onDragLeave, false);
    document.addEventListener('dragenter', this._onDragEnter, false);

    document.addEventListener('drop', this._onDrop, false);
  }

  componentWillUnmount() {
    document.removeEventListener('dragover', this._onDragOver);
    document.removeEventListener('dragleave', this._onDragLeave);
    document.removeEventListener('dragenter', this._onDragEnter);

    document.removeEventListener('drop', this._onDrop);
  }

  _onDragOver = (e) => {
    if (!this.props.enabled) {
      return;
    }

    if (getXPathForElement(e.target).indexOf(this.state.selectorId) === -1) {
      this.setState({ dropZoneActive: null });
    } else {
      this.setState({ dropZoneActive: true });
    }

    e.preventDefault();
    e.stopPropagation();
    return false;
  };

  _onDragEnter = (e) => {
    e.stopPropagation();
    e.preventDefault();
    return false;
  };

  _onDragLeave = (e) => {
    e.stopPropagation();
    e.preventDefault();
    return false;
  };

  _onDrop = (e) => {
    if (!this.props.enabled) {
      return;
    }
    e.preventDefault();
    e.stopPropagation();
    this.props.onDrop(e.dataTransfer.files);
    return false;
  };

  render() {
    return (
      <div id={this.state.selectorId} className={`ct-dropZone${this.state.dropZoneActive ? ' ct-dropZoneActive' : ''}`}>
        {this.props.children}
      </div>
    );
  }
}

DropZone.propTypes = {
  onDrop: PropTypes.func.isRequired,
  enabled: PropTypes.bool,
};
